import type {
  Templates,
  SchedulerTemplatesState,
} from 'src/types/scheduler/templates';
import type {SchedulerTemplatesActions} from 'src/action-creators/scheduler/templates';

import uniqBy from 'lodash/uniqBy';

import {
  SET_INDIVIDUAL_TEMPLATES,
  SET_INDIVIDUAL_TEMPLATES_QUERY_PARAMS,
  ADD_NEW_INDIVIDUAL_TEMPLATE,
  APPEND_INDIVIDUAL_TEMPLATES,
  SET_TEAM_TEMPLATES,
  SET_TEAM_TEMPLATES_QUERY_PARAMS,
  ADD_NEW_TEAM_TEMPLATE,
  APPEND_TEAM_TEMPLATES,
  UPDATE_TEMPLATE,
  COPY_TEMPLATE,
  REMOVE_TEMPLATE,
} from 'src/action-creators/scheduler/templates';


const initialIndividualTemplatesQueryParams = {
  offset: '0',
  limit: '10',
  filters: {
    name: '',
  },
} as const;

const initialTeamTemplatesQueryParams = {
  offset: '0',
  limit: '10',
  filters: {
    name: '',
    bookingAccount: [],
    distributionRule: [],
  },
} as const;

const initialTemplatesState = {
  individualTemplates: {
    data: [],
    totalCount: 0,
    queryParams: initialIndividualTemplatesQueryParams,
  },
  teamTemplates: {
    data: [],
    totalCount: 0,
    queryParams: initialTeamTemplatesQueryParams,
  },
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly individualTemplates: { readonly data: readonly []; readonly totalCount: 0; readonly queryParams: { readonly offset: "0"; readonly limit: "10"; readonly filters: { readonly name: ""; }; }; }; readonly teamTemplates: { ...; }; }' is not assignable to type 'SchedulerTemplatesState'.
  state: SchedulerTemplatesState = initialTemplatesState,
  action: SchedulerTemplatesActions,
): SchedulerTemplatesState => {
  switch (action.type) {
    case SET_INDIVIDUAL_TEMPLATES:
      return {
        ...state,
        individualTemplates: {
          ...state.individualTemplates,
          data: action.payload.data,
          totalCount: action.payload.totalCount,
        },
      };
    case APPEND_INDIVIDUAL_TEMPLATES:
      return {
        ...state,
        individualTemplates: {
          ...state.individualTemplates,
          data: uniqueTemplates([
            ...state.individualTemplates.data,
            ...action.payload.data,
          ]),
          totalCount: action.payload.totalCount,
        },
      };
    case SET_INDIVIDUAL_TEMPLATES_QUERY_PARAMS:
      return {
        ...state,
        individualTemplates: {
          ...state.individualTemplates,
          queryParams: action.payload,
        },
      };
    case ADD_NEW_INDIVIDUAL_TEMPLATE:
      return {
        ...state,
        individualTemplates: {
          ...state.individualTemplates,
          // TODO(Aditya): check where to add the new template in the list add unique template only
          data: uniqueTemplates([
            ...state.individualTemplates.data,
            action.payload,
          ]),
        },
      };

    case SET_TEAM_TEMPLATES:
      return {
        ...state,
        teamTemplates: {
          ...state.teamTemplates,
          data: action.payload.data,
          totalCount: action.payload.totalCount,
        },
      };
    case APPEND_TEAM_TEMPLATES:
      return {
        ...state,
        teamTemplates: {
          ...state.teamTemplates,
          data: uniqueTemplates([
            ...state.teamTemplates.data,
            ...action.payload.data,
          ]),
          totalCount: action.payload.totalCount,
        },
      };
    case SET_TEAM_TEMPLATES_QUERY_PARAMS:
      return {
        ...state,
        teamTemplates: {
          ...state.teamTemplates,
          queryParams: action.payload,
        },
      };
    case ADD_NEW_TEAM_TEMPLATE:
      return {
        ...state,
        teamTemplates: {
          ...state.teamTemplates,
          data: uniqueTemplates([...state.teamTemplates.data, action.payload]),
        },
      };
    case UPDATE_TEMPLATE:
      const updatedTemplate = action.payload;
      if (updatedTemplate.isTeamTemplate) {
        return {
          ...state,
          teamTemplates: {
            ...state.teamTemplates,
            data: state.teamTemplates.data.map((template) =>
              template.id === updatedTemplate.id ? updatedTemplate : template,
            ),
          },
        };
      }
      return {
        ...state,
        individualTemplates: {
          ...state.individualTemplates,
          data: state.individualTemplates.data.map((template) =>
            template.id === updatedTemplate.id ? updatedTemplate : template,
          ),
        },
      };
    case REMOVE_TEMPLATE:
      const {templateId, isTeamTemplate: isTeamTemplateRemove} = action.payload;
      if (isTeamTemplateRemove) {
        return {
          ...state,
          teamTemplates: {
            ...state.teamTemplates,
            data: state.teamTemplates.data.filter(
              (template) => template.id !== templateId,
            ),
          },
        };
      }
      return {
        ...state,
        individualTemplates: {
          ...state.individualTemplates,
          data: state.individualTemplates.data.filter(
            (template) => template.id !== templateId,
          ),
        },
      };
    case COPY_TEMPLATE:
      const {template, isTeamTemplate: isTeamTemplateCopy} = action.payload;
      if (isTeamTemplateCopy) {
        return {
          ...state,
          teamTemplates: {
            ...state.teamTemplates,
            data: [...state.teamTemplates.data, template],
          },
        };
      }
      return {
        ...state,
        individualTemplates: {
          ...state.individualTemplates,
          data: [...state.individualTemplates.data, template],
        },
      };
    default:
      return state;
  }
};

// utils functions
const uniqueTemplates = (templates: Templates): Templates => {
  return uniqBy(templates, 'id');
};
